<template>
  <ul class="list-inline ul-breadcrumb navbar-left">
    <template v-for="(routeObject, index) in routeRecords">
      <li class="active" v-if="isLast(index)">{{ getName(routeObject) }}</li>
      <li v-else><router-link :to="getPath(routeObject.path)">{{ getName(routeObject) }}</router-link></li>
    </template>
  </ul>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      Item: 'OrderController/Item',
      IteamUser: 'v2UserController/IteamUser',
      ClientContractID: 'ContractController/ClientContractID'
    }),
    routeRecords: function() {
      return this.setRoute()
    }
  },
  watch: {
  },
  methods: {
    setRoute() {
      return this.list.map((route,index) => {
        if(index == 1 && (route.meta.type && route.meta.type.includes('breadcrumbs'))) {
          // if(route.path.includes('users')) {
          //   route.meta.label = this.IteamUser && this.IteamUser != null && this.IteamUser.name ? this.IteamUser.name : 'User name'
          // }
          if(route.path.includes('orders')) {
            route.meta.label = this.Item && this.Item != null && this.Item.order_number ? this.Item.order_number : 'Orders number'
          }
        }
        return route
      })
    },
    getPath(val) {
      let path = val.split("/");
      if(path.length >= 3 && path[3] != undefined && path[3].includes(":")) {
        path[3] = this.$route.params.id || this.$route.params.company_id || this.$route.params.account_suplier_id || this.$route.params.organisations_id || this.$route.params.user_id || this.$route.params.maintenance_id;
      }
      if(path.length >= 6 && path[5] != undefined && path[5].includes(":")) {
        path[5] = this.$route.params.equipment_id;
      }
      val = path.join('/');
      return val
    },
    getName (item) {
      return item.meta && item.meta.label ? item.meta.label : null
    },
    isLast (index) {
      return index === this.list.length - 1
    }
  }
}
</script>
